"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_UPLOAD_SIZE_LIMIT_LABEL = exports.MEDIA_UPLOAD_SIZE_LIMIT_BYTES = void 0;
exports.MEDIA_UPLOAD_SIZE_LIMIT_BYTES = {
    image: 3_000_000,
    video: 15_000_000,
};
exports.MEDIA_UPLOAD_SIZE_LIMIT_LABEL = {
    image: "3 MB",
    video: "15 MB",
};
